'use es6';

import createReactClass from 'create-react-class';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import keyMirror from 'react-utils/keyMirror';
import text from 'I18n/utils/unescapedText';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Immutable from 'immutable';
import UIButton from 'UIComponents/button/UIButton';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UISection from 'UIComponents/section/UISection';
import UIIconRating from 'UIComponents/input/UIIconRating';
import UIDropdownSelect from 'UIComponents/dropdown/UIDropdownSelect';
import ReviewCard from '../components/ReviewCard';
import ReviewListZeroState from '../components/ReviewListZeroState';
import { getCanReview } from '../selectors/goodDetails';
import { isBelowMinimumRequiredReviews } from '../utils/utils';

var getI18nKey = function getI18nKey(path) {
  return "goodDetails.reviewList." + path;
};

var MAX_INITIAL_REVIEWS = 6;
var SortDirections = Object.freeze(keyMirror({
  NEWEST_OLDEST: null,
  OLDEST_NEWEST: null,
  HIGHEST_LOWEST: null,
  LOWEST_HIGHEST: null
}));
var ReviewList = createReactClass({
  displayName: "ReviewList",
  propTypes: {
    averageRating: PropTypes.number.isRequired,
    canReview: PropTypes.bool.isRequired,
    reviews: PropTypes.instanceOf(Immutable.List).isRequired,
    triggerReviewModal: PropTypes.func.isRequired
  },
  getInitialState: function getInitialState() {
    var reviews = this.props.reviews;
    return {
      showAllReviews: reviews.size <= MAX_INITIAL_REVIEWS,
      sortDirection: SortDirections.NEWEST_OLDEST
    };
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var showAllReviews = this.state.showAllReviews;
    var reviews = this.props.reviews;
    var nextReviews = nextProps.reviews;

    if (!showAllReviews && reviews.size !== nextReviews.size) {
      this.setState({
        showAllReviews: nextReviews.size <= MAX_INITIAL_REVIEWS
      });
    }
  },
  handleShowAllReviews: function handleShowAllReviews() {
    this.setState({
      showAllReviews: true
    });
  },
  getSortedReviews: function getSortedReviews() {
    var reviews = this.props.reviews;
    var _this$state = this.state,
        showAllReviews = _this$state.showAllReviews,
        sortDirection = _this$state.sortDirection;
    var sortedReviews = reviews;

    switch (sortDirection) {
      case SortDirections.NEWEST_OLDEST:
      case SortDirections.OLDEST_NEWEST:
        {
          sortedReviews = reviews.sortBy(function (review) {
            var updatedAt = review.get('updatedAt');
            return sortDirection === SortDirections.NEWEST_OLDEST ? -updatedAt : updatedAt;
          });
          break;
        }

      case SortDirections.HIGHEST_LOWEST:
      case SortDirections.LOWEST_HIGHEST:
        {
          sortedReviews = reviews.sortBy(function (review) {
            var rating = review.get('rating');
            return sortDirection === SortDirections.HIGHEST_LOWEST ? -rating : rating;
          });
          break;
        }

      default:
        break;
    }

    if (!showAllReviews) {
      sortedReviews = sortedReviews.take(MAX_INITIAL_REVIEWS);
    }

    return sortedReviews;
  },
  handleSortingChange: function handleSortingChange(event) {
    this.setState({
      sortDirection: event.target.value
    });
  },
  renderReviewCard: function renderReviewCard(review, index) {
    return React.createElement(UIGridItem, {
      size: {
        xs: 12,
        md: 4
      },
      key: index
    }, React.createElement(ReviewCard, {
      company: review.get('company'),
      rating: review.get('rating'),
      reviewDate: review.get('updatedAt'),
      reviewText: review.get('contents'),
      userAvatarUrl: review.get('avatarUrl'),
      userFullName: review.get('fullName')
    }));
  },
  renderReviewButton: function renderReviewButton(triggerReviewModal) {
    return React.createElement(UIButton, {
      className: "m-left-4",
      onClick: triggerReviewModal,
      size: "small",
      use: "primary"
    }, React.createElement(FormattedMessage, {
      message: getI18nKey('reviewThisProduct')
    }));
  },
  renderSortingDropdown: function renderSortingDropdown() {
    var selectedSortDirection = this.state.sortDirection;
    var options = Object.keys(SortDirections).map(function (sortDirection) {
      return {
        text: text(getI18nKey("sortingOptions." + sortDirection)),
        value: sortDirection
      };
    });
    return React.createElement(UIDropdownSelect, {
      buttonUse: "link",
      onChange: this.handleSortingChange,
      options: options,
      value: selectedSortDirection
    });
  },
  renderSectionHeader: function renderSectionHeader(reviews, averageRating, isAbleToReview, triggerReviewModal) {
    var showAllReviews = this.state.showAllReviews;
    var totalCount = reviews.size;
    var columnSizes = {
      xs: 12,
      md: 6
    };
    var renderedShowingText = showAllReviews ? React.createElement(FormattedHTMLMessage, {
      message: getI18nKey('showing.all'),
      options: {
        totalCount: totalCount
      }
    }) : React.createElement(FormattedHTMLMessage, {
      message: getI18nKey('showing.initial'),
      options: {
        count: MAX_INITIAL_REVIEWS,
        totalCount: totalCount
      }
    });
    return React.createElement(UISection, null, React.createElement(UIGrid, null, React.createElement(UIGridItem, {
      size: columnSizes
    }, React.createElement("span", {
      className: "is--heading-7 display-inline"
    }, React.createElement(FormattedMessage, {
      message: getI18nKey('header')
    })), React.createElement(UIIconRating, {
      className: "display-inline m-left-4",
      defaultValue: averageRating,
      disabled: true,
      size: "xxs",
      showPercentage: true
    }), React.createElement("span", {
      className: "m-left-1"
    }, "(", totalCount, ")"), isAbleToReview && this.renderReviewButton(triggerReviewModal)), React.createElement(UIGridItem, {
      className: "text-right",
      size: columnSizes
    }, this.renderSortingDropdown(), React.createElement("span", {
      className: "m-left-10"
    }, renderedShowingText))));
  },
  render: function render() {
    var _this$props = this.props,
        averageRating = _this$props.averageRating,
        canReview = _this$props.canReview,
        reviews = _this$props.reviews,
        triggerReviewModal = _this$props.triggerReviewModal;
    var showAllReviews = this.state.showAllReviews;
    var showZeroState = isBelowMinimumRequiredReviews(reviews.size);
    var sortedReviews = this.getSortedReviews();
    return React.createElement(UISection, null, !showZeroState && this.renderSectionHeader(reviews, averageRating, canReview, triggerReviewModal), showZeroState ? React.createElement(ReviewListZeroState, {
      isAbleToReview: canReview,
      triggerReviewModal: triggerReviewModal
    }) : React.createElement(UIGrid, null, sortedReviews.map(this.renderReviewCard), !showAllReviews && React.createElement(UIGridItem, {
      className: "text-center",
      size: 12
    }, React.createElement(UIButton, {
      onClick: this.handleShowAllReviews,
      use: "link"
    }, React.createElement(FormattedMessage, {
      message: getI18nKey('viewAllReviews')
    })))));
  }
});

var select = function select(state) {
  return {
    averageRating: state.goodDetails.get('averageRating'),
    canReview: getCanReview(state),
    reviews: state.goodDetails.get('reviews')
  };
};

var ReviewListContainer = connect(select)(ReviewList);
export default ReviewListContainer;